import React from 'react';
import { Link } from 'react-router-dom';

function RegionCallout() {
  return (
    <div className="mt-10 p-4 bg-blue-50 border border-blue-100 rounded-lg">
      <p className="font-medium text-blue-900">Report scams in your country</p>
      <p className="text-sm text-blue-800 mt-1">
        Official reporting links for Australia, the US, UK, Canada, and more.
      </p>
      <Link
        to="/learn/regions"
        className="inline-block mt-3 text-sm font-medium text-blue-700 hover:underline"
      >
        Browse regional resources →
      </Link>
    </div>
  );
}

export default RegionCallout;
